import React from 'react'
import PropTypes from 'prop-types'
import styles from './BtnPlay.styles.scss'
import PlayIconSVG from './images/play.inline.svg'

const BtnPlay = ({ onClick, ariaLabel }) => {
  const Tag = onClick ? 'button' : 'span'
  const type = onClick ? 'button' : undefined

  return (
    <Tag
      className={styles.el}
      onClick={onClick}
      type={type}
      aria-label={ariaLabel}
    >
      <span className={styles.el__bg} />
      <span className={styles.el__icon}>
        <PlayIconSVG />
      </span>
    </Tag>
  )
}

BtnPlay.defaultProps = {
  ariaLabel: 'Play',
  onClick: undefined,
}
BtnPlay.propTypes = {
  ariaLabel: PropTypes.string,
  onClick: PropTypes.func,
}
export { BtnPlay }
